import { render, staticRenderFns } from "./TabHeaderLink.vue?vue&type=template&id=49ffd654&scoped=true&"
import script from "./TabHeaderLink.vue?vue&type=script&lang=js&"
export * from "./TabHeaderLink.vue?vue&type=script&lang=js&"
import style0 from "./TabHeaderLink.vue?vue&type=style&index=0&id=49ffd654&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49ffd654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
